import React from 'react';

import Icon from '../Icon/Icon';

const AlertIconV2 = (props) => {
    return (
        <Icon width='32' height='32' fill='none' {...props}>
            <path
                d='M23.3839 20.4972C23.0212 20.4972 22.7245 20.196 22.7245 19.8278V13.0029C22.7245 9.5557 20.4119 6.58181 17.1887 5.97938V5.18763C17.1887 4.47643 16.4924 4 15.7999 4C15.0992 4 14.4175 4.4848 14.4175 5.18763V5.97938C11.1943 6.58181 8.87542 9.5557 8.87542 13.0029V19.8278C8.87542 20.196 8.57865 20.4972 8.21594 20.4972C7.41632 20.4972 6.66616 21.0494 6.52602 21.8527C6.34467 22.8902 7.13604 23.7938 8.12526 23.7938H23.4829C24.4721 23.7938 25.2552 22.8902 25.0821 21.8527C24.942 21.0494 24.2 20.4972 23.3922 20.4972H23.3839Z'
                fill='#393E44'
            />
            <path
                d='M25.502 9.2455C25.502 11.2132 23.9068 12.8084 21.9391 12.8084C19.9714 12.8084 18.3762 11.2132 18.3762 9.2455C18.3762 7.27778 19.9714 5.68262 21.9391 5.68262C23.9068 5.68262 25.502 7.27778 25.502 9.2455Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.9391 6.30762C20.3166 6.30762 19.0012 7.62295 19.0012 9.2455C19.0012 10.8681 20.3166 12.1834 21.9391 12.1834C23.5617 12.1834 24.877 10.8681 24.877 9.2455C24.877 7.62295 23.5617 6.30762 21.9391 6.30762ZM17.7512 9.2455C17.7512 6.9326 19.6262 5.05762 21.9391 5.05762C24.252 5.05762 26.127 6.9326 26.127 9.2455C26.127 11.5584 24.252 13.4334 21.9391 13.4334C19.6262 13.4334 17.7512 11.5584 17.7512 9.2455Z'
                fill='#FFFDFB'
            />
            <path
                d='M19 25C19 25.7956 18.6839 26.5587 18.1213 27.1213C17.5587 27.6839 16.7956 28 16 28C15.2044 28 14.4413 27.6839 13.8787 27.1213C13.3161 26.5587 13 25.7956 13 25L19 25Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default AlertIconV2;
